import Overlay from 'ol/Overlay'
/*
 * @Author: alex
 * @Date: 2022-08-28 14:37:44
 * @LastEditors: Alex yxfacw@163.com
 * @LastEditTime: 2023-06-26 17:13:44
 * @Description:
 * Copyright (c) 2022 by piesat, All Rights Reserved.
 */
import { BaseMapTool } from './mapToolBase'

import { getNanoId } from '@vmap/core'

interface MapOverlayEvent {
  [_: string]: any
}

export default class MapOverlayTool extends BaseMapTool<MapOverlayEvent> {
  /**
   * 保存所有的overlay
   */
  #overlays: Map<string, Overlay> = new Map()

  protected startInternal(): void {
    //
  }

  protected stopInternal(): void {
    //
  }

  clear() {
    //
    this.#overlays.forEach(value => {
      this.map.removeOverlay(value)
    })
    this.#overlays.clear()
  }

  /**
   * 添加 marker
   * TODO: 默认样式
   * @param position -点坐标
   * @param classNameOrStyle marker 样式
   * @param centerAt  是否居中显示
   * @returns
   */
  addMarker(
    position: [number, number],
    classNameOrStyle: string | Record<string, string>,
    centerAt = false
  ): string {
    const content: HTMLDivElement = document.createElement('div')
    if (typeof classNameOrStyle === 'string') {
      content.className = classNameOrStyle
    } else {
      const cssTexts: string[] = []
      Object.keys(classNameOrStyle).forEach(key => {
        cssTexts.push(`${key}:${classNameOrStyle[key]}`)
      })
      content.style.cssText = cssTexts.join(';')
    }

    return this.addOverlay(content, position, centerAt)
  }

  /**
   *  添加 overlay，可用于添加地图弹窗以及覆盖 html 元素等
   *
   * @param content html元素内容
   * @param position 坐标点位置
   * @param centerAt 地图在该点居中
   * @param [stopEvent=true]
   * @returns id
   */
  addOverlay(
    content: HTMLElement,
    position: [number, number],
    centerAt = false,
    stopEvent = true
  ): string {
    const id = getNanoId()
    const overlay = new Overlay({
      position: position,
      positioning: 'center-center',
      //   offset:
      element: content,
      stopEvent: stopEvent,
      autoPan: {
        animation: {
          duration: 250
        }
      }
    })
    // FIXME: id可能未生效
    overlay.set('id', id)
    this.map.addOverlay(overlay)
    if (centerAt) {
      this.map.getView().setCenter(position)
    }
    this.#overlays.set(id, overlay)
    return id
  }

  /**
   * 移除当前已添加的overlay
   * @param id overlay id
   * @returns
   */
  removeOverlay(id: string): boolean {
    if (this.#overlays.has(id)) {
      const overlay = this.#overlays.get(id) as Overlay
      overlay.setElement(undefined)
      overlay.setPosition(undefined)
      this.map.removeOverlay(overlay)
      return true
    }
    return false
  }
}
